var content = require("!!../../../../node_modules/.pnpm/css-loader@3.2.0_webpack@4.32.2/node_modules/css-loader/dist/cjs.js!./react-big-calendar-overrides.css");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../../../node_modules/.pnpm/style-loader@1.0.0_webpack@4.32.2/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
